import { FirebaseList } from '../firebase';
import * as lotteriesActions from './actions';
import { Lottery } from './lottery';

export const lotteryList = new FirebaseList(
  {
    onAdd: lotteriesActions.createLotterySuccess,
    onChange: lotteriesActions.updateLotterySuccess,
    onLoad: lotteriesActions.loadLotteriesSuccess,
    onRemove: lotteriesActions.deleteLotterySuccess,
  },
  Lottery,
);



// WEBPACK FOOTER //
// ./src/core/lotteries/lottery-list.js